import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Dropdown } from 'react-bootstrap';
import '../styles/navbar.css';
import { Link, useNavigate } from 'react-router-dom';
import API_URL from "../config/api";

const NavigationBar = () => {
    const [prevScrollPos, setPrevScrollPos] = useState(window.pageYOffset);
    const [visible, setVisible] = useState(true);
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem("user"));
    const [username] = useState(user?.username || "");
    const [isAdmin] = useState(user?.role === "admin");
    const [visitorCount, setVisitorCount] = useState(0);

    const logout = () => {
        localStorage.removeItem("user");
        navigate("/AuthPage");
    };

    // Handle scroll visibility
    useEffect(() => {
        const handleScroll = () => {
            const currentScrollPos = window.pageYOffset;
            setVisible(prevScrollPos > currentScrollPos || currentScrollPos < 10);
            setPrevScrollPos(currentScrollPos);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [prevScrollPos, visible]);

    useEffect(() => {
        const loadVisitors = async () => {
            try {
                if (!sessionStorage.getItem("visited")) {
                    await fetch(`${API_URL}/visitor/add_visit.php`
                    );
                    sessionStorage.setItem("visited", "true");
                }
                const response = await fetch(`${API_URL}/visitor/get_visitor_count.php`
                );
                const data = await response.json();
                setVisitorCount(data.count);
            } catch (err) {
                console.error(err);
            }
        };
        loadVisitors();
    }, []);

    return (
        <Navbar
            className={`sticky-nav ${visible ? 'visible' : 'hidden'}`}
            style={{ backgroundColor: 'rgba(0, 100, 0, 0.8)' }}
            expand="lg"
            sticky="top"
        >
            <Navbar.Brand href="/">
                <div className="logo">
                    <img
                        src="/img/arbologo.png"
                        alt="Logo"
                        className="icon"
                        style={{ width: '50px', background: 'white', borderRadius: '50%', marginRight: '20px' }}
                    />ARBOREATRIX
                </div>
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse className="nav-collapse justify-content-center" id="basic-navbar-nav">
                <Nav className="nav_bar mr-auto">
                    <Nav.Link className="nav_link_custom" href="/">Home</Nav.Link>
                    <Nav.Link className="nav_link_custom" href="/#/AboutUs">About</Nav.Link>
                    <Nav.Link className="nav_link_custom" href="/#/ContactForm">Contact</Nav.Link>
                    <Nav.Link className="nav_link_custom" href="/#/Feedback">Feedback</Nav.Link>
                    <Nav.Link className="button1" href="/#/AddTree">Add Tree</Nav.Link>
                </Nav>

                {/* Show visitor count */}
                <div style={{ color: 'white', fontWeight: 'bold', marginRight: '20px', fontSize: '14px'}}>
                    No. of Visitors: {visitorCount}
                </div>

                {user && (
                    <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                            Account
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu-right" style={{ left: '-15px' }}>
                            <Dropdown.ItemText>
                                Welcome, {username}
                            </Dropdown.ItemText>
                            {isAdmin && (
                                <Dropdown.Item>
                                    <Link to='/Home' style={{ textDecoration: 'none', color: 'black' }}>
                                        Admin Dashboard
                                    </Link>
                                </Dropdown.Item>
                            )}
                            <Dropdown.Item
                                style={{ background: 'red', color: 'white' }}
                                onClick={logout}
                            >
                                Logout
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                )}
            </Navbar.Collapse>
        </Navbar>
    );
};

export default NavigationBar;
